'use strict';

var escapeXmlAttr = require('raptor-util/escapeXml').attr;

module.exports = function formatTag(element, data, context) {
    var elementData = data && data[element.id];
    var attributes = Object.assign({},
        elementData && elementData.attributes,
        // resolve any attributes with placeholder
        resolveDynamicAttributes(element.attributes, data, context));

    element = Object.assign({}, element, {
        attributes: attributes
    });
    context.renderTag = context.renderTag = renderTag;
    // format/resolve tag attributes
    var format = context && context.formatters &&
        (context.formatters[element.id] ||
            context.formatters['tag:' + element.id] ||
            context.formatters['tag:' + element.type] ||
            context.formatters[element.type]) || renderTag;
    // generate tag
    return format(element, data, context);
};

function renderTag(element, data, context) {
    var tag = '<' + element.name;
    Object.keys(element.attributes || {}).forEach(function (key) {
        var value = element.attributes[key];
        var val = value.value === undefined ? value :
            (value.escape ? escapeXmlAttr(value.value) : value.value);
        tag += ' ' + key + '="' + (val) + '"';
    });
    // add children if any and then close the tag
    if (element.children.length > 0) {
        tag += '>';
        element.children.forEach(function (part) {
            if (typeof part === 'string') {
                tag += part;
            }
            else {
                tag += part.resolve(data, context);
            }
        });
        if (element.dual) {
            tag += '</' + element.name + '>';
        }
    }
    else {
        tag += (element.closed ? '/' : '') + '>';
        if (element.dual) {
            tag += '</' + element.name + '>';
        }
    }
    return tag;
}

module.exports.renderTag = renderTag;

function resolveDynamicAttributes(attrs, data, context) {
    if (attrs && attrs.$dynamicAttributes) {
        var ret = {};
        Object.keys(attrs).forEach(function (name) {
            if (name === '$dynamicAttributes') {
                return;
            }
            var val = attrs[name];
            var escape;
            if (Array.isArray(val)) {
                var content = '';
                val.forEach(function (part) {
                    if (typeof part === 'string') {
                        content += part;
                    }
                    else {
                        if (part.options && part.options.escape === false) {
                            escape = false;
                        }
                        content += part.resolve(data, context);
                    }
                });
                val = content;
            }
            ret[name] = escape !== undefined ? {
                value: val,
                escape: escape
            } : val;
        });
        return ret;
    }
    return attrs;
}
